import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import RegisterFormCoppa from './RegisterFormCoppa';
import SendParentEmailForm from '../SendParentEmailForm';
import Layout from '../../../layout/Layout';
import { useTranslation } from 'react-i18next';

const ChildRegister = (props) => {
  const { birthday } = props;
  const history = useHistory();
  const [childInfo, setChildInfo] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();

  const handleChildInfoSubmit = (info) => {
    setChildInfo({ ...info, birthday });
  };

  const handleChildRegistration = async (data) => {
    setLoading(true);
    setError('');
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/users/v1/children`, {
        method: 'POST',
        body: JSON.stringify({ ...childInfo, parent_email: data.email }),
        headers: {
          'Content-Type': 'application/json',
        },
      });
      if (response.ok) {
        // Clear stored birthday date
        window.sessionStorage.removeItem('birthday');
        // if come from a coppa flow show the right login form
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.get('loginCoppa')) {
          urlParams.set('loginCoppa', 'kid-login');
          window.history.replaceState(
            {},
            document.title,
            window.location.pathname + '?' + urlParams.toString() + window.location.hash
          );
        }
        history.push({
          pathname: '/login',
          query: { parentEmail: data.email },
        });
      } else {
        setError(t('sendParentEmail:error'));
      }
    } catch (e) {
      setError(t('sendParentEmail:error'));
    } finally {
      setLoading(false);
    }
  };

  return childInfo ? (
    <Layout onBack={() => setChildInfo(null)} isChild={true}>
      <SendParentEmailForm onSubmit={handleChildRegistration} error={error} loading={loading} />
    </Layout>
  ) : (
    <Layout isChild={true}>
      <RegisterFormCoppa onSubmit={handleChildInfoSubmit} />
    </Layout>
  );
};

ChildRegister.propTypes = {
  birthday: PropTypes.string.isRequired,
};

export default ChildRegister;
